import React, {Component} from 'react'
import Mapa from "./Mapa";
import Newsletter from "./Newsletter";
import Footer from "../../shared/Footer";

export default class MapaComponent extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return <div>
            <div className="przerywnik-odwrotny">
                <h1 className="text-center" style={{fontWeight: 'bold', textShadow: '3px 3px 3px rgba(0, 0, 0, 0.75)'}}>
                    Skorzystaj z naszej <a style={{color: '#8dc846'}}>mapy połączeń!</a>
                </h1>
            </div>
            <Mapa/>
            <Newsletter/>
            <div className="container-fluid przerywnik">
                <h1 className="text-center" style={{fontWeight: 'bold', textShadow: '3px 3px 3px rgba(0, 0, 0, 0.75)'}}>
                    Podróżuj razem z nami <a style={{color: '#8dc846'}}>bezpiecznie i komfortowo!</a>
                </h1>
            </div>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/MapaComponent.js